(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonial01"] && !Shopify.designMode) return;
  try {
    
  class TestimonialMarquee extends HTMLElement {
    constructor() {
      super();
      const marquee = this.querySelector('.testimonial-marquee');
      if (!marquee) return;
      const speed = parseInt(marquee.dataset.speed) || 80;
      const duration = Math.max(10, 150 - speed);
      marquee.style.setProperty('--duration', duration + 's');
    }
  }
  customElements.define('testimonial-marquee', TestimonialMarquee);
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.testimonial-section');
    if (section) {
      const wrapper = document.createElement('testimonial-marquee');
      section.parentNode.insertBefore(wrapper, section);
      wrapper.appendChild(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-bar-small"] && !Shopify.designMode) return;
  try {
    
  class TestimonialSlider {
    constructor(sliderId) {
      this.slider = document.getElementById(sliderId);
      if (!this.slider) return;

      this.track = this.slider.querySelector('.testimonial-track');
      this.slides = Array.from(this.track.querySelectorAll('.testimonial-slide'));
      this.prevBtn = document.querySelector(`[data-slider="${sliderId}"].slider-btn--prev`);
      this.nextBtn = document.querySelector(`[data-slider="${sliderId}"].slider-btn--next`);
      this.currentIndex = 0;
      this.autoScrollInterval = null;

      // Get auto-scroll speed from section settings (in seconds, default 5)
      const sectionEl = this.slider.closest('.testimonial-slider-38');
      this.autoScrollSpeed = parseInt(sectionEl.dataset.autoScrollSpeed || 5) * 1000;

      this.init();
    }

    init() {
      // Clone slides for infinite loop
      this.cloneSlides();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      // Start auto-scroll
      this.startAutoScroll();

      // Pause on hover
      this.track.addEventListener('mouseenter', () => this.stopAutoScroll());
      this.track.addEventListener('mouseleave', () => this.startAutoScroll());
    }

    cloneSlides() {
      const originalSlides = Array.from(this.track.children);
      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      });
    }

    startAutoScroll() {
      this.stopAutoScroll();
      this.autoScrollInterval = setInterval(() => {
        this.next(true);
      }, this.autoScrollSpeed);
    }

    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    }

    prev() {
      this.stopAutoScroll();
      const slidesToShow = this.getSlidesToShow();
      this.currentIndex = Math.max(0, this.currentIndex - slidesToShow);
      this.updateSlider();
      this.startAutoScroll();
    }

    next(isAuto = false) {
      const slidesToShow = this.getSlidesToShow();
      const totalSlides = this.slides.length;

      this.currentIndex++;

      // Reset to beginning seamlessly when reaching duplicates
      if (this.currentIndex >= totalSlides) {
        this.track.style.transition = 'none';
        this.currentIndex = 0;
        this.updateSlider(true);

        setTimeout(() => {
          this.track.style.transition = 'transform 0.5s ease';
          this.currentIndex = 1;
          this.updateSlider();
        }, 20);
      } else {
        this.updateSlider();
      }

      if (!isAuto) {
        this.stopAutoScroll();
        this.startAutoScroll();
      }
    }

    getSlidesToShow() {
      return window.innerWidth > 768
        ? parseInt(getComputedStyle(this.track).getPropertyValue('--slides-desktop') || 2)
        : parseInt(getComputedStyle(this.track).getPropertyValue('--slides-mobile') || 1);
    }

    updateSlider(instant = false) {
      const slideWidth = this.slides[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 12;
      const offset = -(this.currentIndex * (slideWidth + gap));

      if (instant) {
        this.track.style.transform = `translateX(${offset}px)`;
      } else {
        this.track.style.transition = 'transform 0.5s ease';
        this.track.style.transform = `translateX(${offset}px)`;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('[id^="slider-"]');
    sliders.forEach(slider => {
      new TestimonialSlider(slider.id);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
